export const SALA_AIA_ORGANIZATION_ID = 'f9d51260-284c-43f6-b02b-0f0436f65152';
export const SALA_MAXICARE_ORGANIZATION_ID =
    '5a9de73d-e834-44ea-bdfd-444ad3a0d6f9';
export const ATOMIX_ORGANIZATION_ID = '9309693d-c537-4cbc-9ca7-68ea2aa396d6';
export const ATOMIX_NO_PHI_ORGANIZATION_ID =
    '0a42e458-9485-4453-9d7f-7df190f798f8';
export const MEDICARD_EXTERNAL_ORGANIZATION_ID =
    'dfc857d7-ea08-45ac-b910-36b947074c7f';
export const RPM_ORGANIZATION_ID = 'c06c248b-c9e0-4379-9ae9-edce64c93f70';
export const ASTER_ORGANIZATION_ID = 'bfcb9d1f-3fdc-4da1-8b5c-ff48e2492f78';
export const ASIAN_HOSPITAL_ORGANIZATION_ID =
    'e718d255-8c31-4a77-a220-6261d193d989';
